<div id="title">
    
    <button mat-icon-button (click)="toggleTextExpansion()">
        <mat-icon [@halfTurn]="expanded ? 'open' : 'closed'" (@halfTurn.done)="animationInProgress = false">expand_more</mat-icon>
    </button>
    
    <ng-content select="h1,h2,h3,h4">

    </ng-content>


</div>

<div id="text" [@expand]="expanded ? 'full' : 'collapsed'">
    <ng-content select="[slot=text]"  *ngIf="expanded || animationInProgress">

    </ng-content>
</div>